<script lang="ts">
	import type { AllergiesProps } from "../templates/WeddingsProps";
	import Icon from "./Icon.svelte";

	export let allergies: AllergiesProps[];
</script>

<div>
	<h2 class="decorative-headline">Alergie</h2>
	<div class="mt-12 flex flex-col flex-wrap items-center gap-6 sm:flex-row sm:items-stretch lg:justify-between">
		{#each allergies as allergy}
			<div
				class="border-secondary-200 relative flex max-w-[21.25rem] flex-col rounded-2xl border p-6 sm:basis-[calc(50%-0.75rem)] lg:max-w-[initial] lg:basis-[calc((100%-(2*1.5rem))/3)]"
			>
				<Icon class="mb-4 h-20 w-20 lg:h-[4.25rem] lg:w-[4.75rem]" icon={allergy.icon} />
				<div class="flex flex-col gap-4">
					<p class="text-md font-semibold leading-[1.35] lg:text-lg">{allergy.title}</p>
					<p class="text-xs lg:text-base">{allergy.description}</p>
				</div>
			</div>
		{/each}
	</div>
</div>
